import PropTypes from 'prop-types';
import React from 'react';
import Button from '../button';
import { FollowMemberIcon, FollowingIcon } from '../icons';
import styles from './follow-user-button-mobile.scss';

const FollowUserButtonMobile = ({ user, onClick, children, ...props }) => {
  const handleClick = e => {
    e.preventDefault();
    onClick(e);
  };
  return (
    <div className={styles.container}>
      <Button className={styles.button} onClick={handleClick} isSecondary={user.isSubscribed} {...props}>
        {user.isSubscribed ?
          <FollowingIcon className="button-secondary-icon-fill"/> :
          <FollowMemberIcon className="button-primary-icon-fill"/>}
      </Button>
      {children}
    </div>
  );
};

FollowUserButtonMobile.propTypes = {
  user: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default FollowUserButtonMobile;



// WEBPACK FOOTER //
// ./app/components/follow-user-button-mobile/follow-user-button-mobile.js